import moment from 'moment';
import * as React from 'react';
import { useTranslation } from 'react-i18next';

import { Modules, useLoggedInUserPermissions } from '~/components/Auth';
import { ListWidgetComponentFactory } from '~/components/MyWorkspace/ListWidget';
import { WithPerspectives } from '~/components/MyWorkspace/ManagePerspectives';
import { PeopleTabs } from '~/data/tabs';
import { useWorkspaceSettings } from '~/scenes/MyWorkspace/hooks';
import { People } from '~/services/Http';
import { useGetTeamAbsences } from '~/services/Http/hooks';

import { WidgetProps } from '../../data/widgets';

import { Absence } from './components/Absence';
import { AbsenceInfo } from './components/AbsenceInfo';

export interface Props extends WidgetProps<WithPerspectives> {}

const TeamAbsencesTodayWidgetComponent = ListWidgetComponentFactory({
  ListItemComponent: Absence,
  getIdentifier: (item: People.AbsenceDto) => item.id,
  ListItemInfoComponent: AbsenceInfo,
  dataCy: 'team-absences-today-widget',
});

export const TeamAbsencesTodayWidget: React.FC<Props> = ({ title }) => {
  const { t } = useTranslation();
  // TODO activeWorkspaceRole should be passed through as part of perspective
  const { activeWorkspaceRole } = useWorkspaceSettings();

  const getTeamAbsencesReqParams = {
    employeeId: 'me',
    startDate: moment().startOf('day').toDate(),
    endDate: moment().endOf('day').toDate(),
    roles: [activeWorkspaceRole],
  };
  const {
    data: absences,
    loading,
    failedToLoad,
  } = useGetTeamAbsences(getTeamAbsencesReqParams);

  const permissions = useLoggedInUserPermissions();
  const peopleModuleEnabledTabs = permissions.enabledTabs[Modules.PEOPLE];

  return (
    <TeamAbsencesTodayWidgetComponent
      title={title || t('teamAbsencesToday')}
      noDataMessage={t('noAbsencesToday')}
      data={absences}
      loading={loading}
      failedToLoad={failedToLoad}
      isTabDisabled={
        !!peopleModuleEnabledTabs &&
        !peopleModuleEnabledTabs.includes(PeopleTabs.ABSENCES)
      }
    />
  );
};
